(function() {
	'use strict';

	angular.module('quantixApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider', '$ocLazyLoadProvider' ];

	function stateConfig($stateProvider, $ocLazyLoadProvider) {
		

		$ocLazyLoadProvider
				.config({
					'debug' : false, /*
										 * for debugging ocLazyLoad module
										 * 'true/false'
										 */
					'events' : true, /*
										 * for event ocLazyLoad module
										 * 'true/false'
										 */
					'modules' : [
							{
								name : 'financialDetailsModule',  
								files : [
									'app/services/projections/projectionAndDisplay.service.js',
									'app/company/financials/userUploadCompanyFinancial.controller.js',
									'app/company/financials/WidgetSettings.Controller.js',
										'app/company/financials/financialDetails.controller.js',
										'app/industry/smemargin/smemargin.controller.js',
										'app/services/portfolio/portfolio.service.js'
										
										]
							}

					]
				});
		
		
		
		
		
		
		
		
		$stateProvider
				.state(
						'financialDetails',
						{
							parent : 'app',
							url : '/financialDetails',
							params : {
				            	companyCode : null ,
				            	IsSearch:null,
				            	companyName : null
							},
							data : {
								authorities : []
							},
							views : {
								'content@' : {
									templateUrl : 'app/company/financials/financialDetails.html',
									controller : 'FinancialDetailsController',
									controllerAs : 'vm'
								}
							},
							resolve : {
								loadMyCtrl : [
										'$ocLazyLoad',
										function($ocLazyLoad) {
											return $ocLazyLoad
													.load('financialDetailsModule'); /*
																						 * Resolve
																						 * promise
																						 * and
																						 * load
																						 * before
																						 * view
																						 */
										} ]
							}
						})
	}
})();
